import { render, staticRenderFns } from "./CreatePayrollType.vue?vue&type=template&id=133dd1f7"
import script from "./CreatePayrollType.vue?vue&type=script&lang=js"
export * from "./CreatePayrollType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports